import { useState } from "react"
import { Button, Input } from "antd"
import { URL_BASE } from "../constants/url"
import { get, getFile } from "../utils/fetch"

const LISTA_IDS_URL = `${URL_BASE}/api/Pagos2/ListaOP`
const DOWNLOAD_URL  = `${URL_BASE}/api/OrdenPago/DownloadDocumentoOP`
const PASSWORD      = "1234"
const DELAY         = 5000

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

async function ejecutarDescarga() {
  const { data } = await get(LISTA_IDS_URL)

  for (const item of data) {
    try {
      await getFile(`${DOWNLOAD_URL}/${item.ordenPagoID}/3`, `OP_${item.ordenPagoID}.xml`)
    } catch (e) {
      console.warn(`Falló ${item.ordenPagoID}`, e)
    }
    await sleep(DELAY)
  }
}

export default function DescargaMasiva() {

  const [password, setPassword] = useState("")
  const [enabled, setEnabled]   = useState(false)

  function validar() {
    if (password === PASSWORD) setEnabled(true)
  }

  return (
    <div>

      <h2>Descarga Masiva</h2>

      {!enabled && (
        <>
          <Input
            placeholder="Password"
            style={{ width: 200 }}
            onChange={e => setPassword(e.target.value)}
          />
          <Button type="danger" onClick={validar}>
            Entrar
          </Button>
        </>
      )}

      {enabled && (
        <Button type="danger" onClick={ejecutarDescarga}>
          Iniciar Descarga
        </Button>
      )}

    </div>
  )
}